<template>
  <div
    class="cell-compensation"
    :class="{ 'cell-compensation-hover': record.compensation.is_need && canEdit, 'cell-compensation_disabled': !canEdit }"
    @click="showCompensationModal"
  >
    <m-compensation
      :active="isShowCompensationModal"
      @close="isShowCompensationModal = false"
      @sendCompensationValue="setCompensation"
      :record="record"
      :calc-data="calculationData"
    />
    <div :class="{ 'cell-compensation-value-grey': record.compensation.value === 0 }" class="cell-compensation-value">
      {{ record.compensation.value }}
    </div>
  </div>
</template>

<script>
import CompensationModal from "@/pages/calculations/create/additions/modal-production-compensation";

export default {
  name: "production-cell-compensation",
  components: {
    "m-compensation": CompensationModal,
  },
  props: ["record", "calculationData", "canEdit"],
  data() {
    return {
      isShowCompensationModal: false,
    };
  },
  methods: {
    showCompensationModal() {
      if (!this.canEdit || !this.record.compensation.is_need) {
        return;
      }
      this.isShowCompensationModal = true;
    },
    setCompensation(value) {
      this.$emit("updateCompensation", value)
      this.record.compensation.value = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-compensation {
  line-height: 13px;
  font-size: 13px;
  padding: 10px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &-hover {
    &:hover {
      outline-style: solid;
      outline-width: 1px !important;
      outline-color: #0066ff !important;
      box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
    }
  }

  &_disabled {
    cursor: default;

    &.cell-compensation-hover:hover {
      outline: none;
      box-shadow: none;
    }
  }

  &-value {
    &-grey {
      color: #8e9cbb;
    }
  }
}
</style>
